import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router";

function DevLayout() {
  return (
    <div className="flex h-full flex-col font-mono">
      <nav className="flex items-center gap-1 border-b border-border bg-muted/30 px-4 py-2 text-sm">
        <span className="mr-3 font-semibold text-muted-foreground">DEV</span>
        <NavTab to="/dev/documents" label="Documents" />
        <NavTab to="/dev/audits" label="Audits" />
        <NavTab to="/dev/checklist" label="Checklist" />
        <NavTab to="/dev/notifications" label="Notifications" />
      </nav>
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}

function NavTab({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      search={(prev) => prev}
      params={(prev) => prev}
      className="rounded px-3 py-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      activeProps={{ className: "rounded px-3 py-1 bg-muted text-foreground font-medium" }}
    >
      {label}
    </Link>
  );
}

export const Route = createFileRoute("/dev")({
  component: DevLayout,
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/" });
    }
  },
});
